<script>
import { mapActions } from 'vuex'
import { list, get, duplicate, del } from '@/api/acessorelatorio'

// Colunas
import columns from './colunas'

export default {
  props: {
    mode: { type: String, default: 'tab' }
  },
  data () {
    return {
      acoes: {
        add: 'acesso_relatorio_incluir',
        edit: 'acesso_relatorio_editar',
        delete: 'acesso_relatorio_excluir'
      },
      columns: columns,
      indices: [
        { value: 'tela.descricao', label: 'Tela' },
        { value: 'funcionalidade.descricao', label: 'Funcionalidade' },
        { value: 'acesso_relatorios.nome', label: 'Nome' }
      ],
      outrosBotoes: [
        { class: 'export', permissao: 'acesso_relatorio_duplicar', evento: this.duplicar }
      ]
    }
  },
  methods: {
    ...mapActions({
      newModal: 'modal/new',
      openModal: 'modal/open',
      confirmarModal: 'modal/confirmar',
      toaster: 'modal/toaster'
    }),
    refresh (data) {
      if (this.mode === 'tab') this.$refs.completeGrid.refreshList()
      else if (this.mode === 'modal') this.$refs.completeGrid.changeBusca(data)
    },
    async getList (filtros) {
      let data = await list(filtros)
      return {
        data: data.data,
        totalCount: data.total
      }
    },
    async duplicar (row) {
      if (row.data && row.data.id) {
        this.confirmarModal({
          msg: 'Deseja realmente duplicar esse relatório?',
          onConfirm: async () => {
            await duplicate(row.data.id)
            this.toaster({ message: 'Duplicado com sucesso!', color: 'success' })
            this.$refs.completeGrid.refreshList()
          }
        })
      }
    },
    async novo () {
      let data = { impressao: false, tela: {}, funcionalidade: {}, nome: '', descricao: '', filtros: '', report: null, urlDados: '' }
      this.$emit('onEdit', data)
    },
    async editar (row) {
      let data = await get(row.data.id)
      data.impressao = !!data.impressao
      this.$emit('onEdit', data)
    },
    async excluir (row) {
      this.confirmarModal({
        msg: 'Deseja realmente excluir esse relatório?',
        onConfirm: async () => {
          await del(row.data.id)
          this.toaster({ message: 'Excluido com sucesso!', color: 'success' })
          this.$refs.completeGrid.refreshList()
        }
      })
    },
    async selecionar (selecionado) {
      if (selecionado.id) this.$emit('save', selecionado)
    }
  }
}
</script>

<template>
  <ui-layout-modal :mode="mode" title="Listar Relatório" @onClose="() => $emit('cancel')">
    <ui-complete-grid
      ref="completeGrid"
      :columns="columns"
      :indices="indices"
      :selection="mode === 'modal'"
      :datasource="getList"
      :acoes="acoes"
      :outrosBotoes="outrosBotoes"
      @onSelect="selecionar"
      @onCancel="$emit('cancel')"
      @onAdd="novo"
      @onEdit="editar"
      @onDelete="excluir" />
  </ui-layout-modal>
</template>
